/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.feature.settings.sections

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.OutlinedCard
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.stringResource
import studio.oddpods.cauce.core.designsystem.icon.AppIcons
import studio.oddpods.cauce.feature.settings.generated.resources.Res
import studio.oddpods.cauce.feature.settings.generated.resources.feature_settings_notification_title

@Composable
internal fun NotificationsSection(
    onNavigateToNotifications: () -> Unit,
    modifier: Modifier = Modifier,
) {
    OutlinedCard(
        shape = RoundedCornerShape(8.dp),
        elevation = CardDefaults.cardElevation(defaultElevation = 1.dp),
        modifier = modifier.fillMaxWidth(),
        onClick = onNavigateToNotifications,
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Icon(
                imageVector = AppIcons.OutlinedNotifications,
                contentDescription = null,
                modifier = Modifier
                    .padding(horizontal = 8.dp)
                    .clip(shape = RoundedCornerShape(50.dp)),
            )
            Text(
                text = stringResource(Res.string.feature_settings_notification_title),
                modifier = Modifier.weight(1F),
            )
            IconButton(onClick = onNavigateToNotifications) {
                Icon(
                    imageVector = AppIcons.ArrowRight,
                    contentDescription = stringResource(Res.string.feature_settings_notification_title),
                )
            }
        }
    }
}
